/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */

import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';
import Colors from '@global/colors';
import { isWeb, isAndroid } from '@global/screens';
import useCommentUnread from './useCommentUnread';

// Web-only floating variant. On mobile the equivalent entry point lives in the header
// instead (see CommentHeaderButton.js) — there's no floating button in the mobile design.
const FloatCommentButton = ({
  onPress,
  entityType,
  entityId,
  hasUnread,
  drawerVisible,
  bottomOffset = 24,
}) => {
  const insets = useSafeAreaInsets();
  const [showUnread, clearUnread] = useCommentUnread({
    entityType,
    entityId,
    hasUnread,
    drawerVisible,
  });

  const onPressButton = () => {
    // Clear the dot the moment the drawer opens, rather than waiting for the next fetch —
    // the user is about to read the comments right now.
    clearUnread();
    onPress();
  };

  return (
    <TouchableOpacity
      testID="float-comment-btn"
      activeOpacity={0.8}
      onPress={onPressButton}
      style={{
        position: isWeb ? 'fixed' : 'absolute',
        right: 24,
        bottom: bottomOffset + (isAndroid ? insets.bottom : 0),
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: Colors.blue0,
        borderRadius: 12,
        paddingVertical: 8,
        paddingHorizontal: 16,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.2,
        shadowRadius: 6,
        elevation: 6,
        zIndex: 15,
      }}>
      <View style={{ position: 'relative', marginRight: 8 }}>
        <Image
          source={require('@assets/img/icons/comment-white.svg')}
          style={{ width: 18, height: 18 }}
          width={18}
          height={18}
          svg={true}
        />
        {showUnread ? (
          <View
            style={{
              position: 'absolute',
              top: -4,
              right: -4,
              width: 10,
              height: 10,
              borderRadius: 5,
              backgroundColor: Colors.red3,
            }}
          />
        ) : (
          false
        )}
      </View>
      <SociollaText type="medium" style={{ color: Colors.white, fontSize: 13 }}>
        Comment
      </SociollaText>
    </TouchableOpacity>
  );
};

export default FloatCommentButton;
